import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./components/context/Context";
import { ParallaxProvider } from "react-scroll-parallax";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <ParallaxProvider>
            <AppProvider>
                <App />
            </AppProvider>
        </ParallaxProvider>
    </React.StrictMode>
);

reportWebVitals();
